module.exports = __webpack_public_path__ + "img/icon_phone.9b8d927.svg";